import { Expression } from "@/components/Expressions/types";
import { UseAIValue } from "./ValueForms/AIRuleForm";
// import { UseAutomationValue } from "./ValueForms/AutomationRuleForm"; // Commented out - outdated
import { AutoResolveChatValue } from "./ValueForms/AutoResolveChatRuleForm";
import { CreateCrmRecordValue } from "./ValueForms/CreateCrmRecordRuleForm";
// import { LanguageConfigValue } from "./ValueForms/LanguageConfigRuleForm"; // Commented out - outdated
// import { StyleConfigValue } from "./ValueForms/StyleConfigRuleForm"; // Commented out - outdated
import { WorkflowOnResolveValue } from "./ValueForms/WorkflowOnResolveRuleForm";
import { SurveyRuleFormValue } from "./ValueForms/SurveyRuleForm";
import { ChatWindowValue } from "./ValueForms/ChatWindowRuleForm";
import { RouteToTeamValue } from "./ValueForms/RouteToTeamRuleForm";
import { PriorityRuleFormValue } from "./ValueForms/PriorityRuleForm";

export type RuleValue =
  // | UseAutomationValue // Commented out - outdated
  | UseAIValue
  | CreateCrmRecordValue
  | AutoResolveChatValue
  // | LanguageConfigValue // Commented out - outdated
  // | StyleConfigValue // Commented out - outdated
  | WorkflowOnResolveValue
  | SurveyRuleFormValue
  | ChatWindowValue
  | RouteToTeamValue
  | PriorityRuleFormValue;

export const triggerDefs = {
  // "use-automation": "Use Automation", // Commented out - outdated
  "use-ai": "Use AI",
  "route-to-team": "Route to Team",
  "create-crm-record": "Create CRM Record",
  "resolve-chat": "Resolve Chat",
  // "determine-language-config": "Determine Language Config", // Commented out - outdated
  // "determine-style-config": "Determine Style Config", // Commented out - outdated
  "use-workflow-on-resolve": "Use Workflow on Conversation Resolve",
  "use-workflow-on-unavailable":
    "Use Workflow when Conversation is Unavailable",
  "use-prechat-survey": "Use Prechat Survey",
  "use-postchat-survey": "Use Postchat Survey",
  "use-unavailable-survey": "Use Unavailable Survey",
  "determine-chat-window": "Determine Chat Window",
  "set-conversation-priority": "Set Conversation Priority (VIP Queue)"
};

export type RuleTrigger = keyof typeof triggerDefs;

export const triggerDescriptions: Partial<Record<RuleTrigger, string>> = {
  "use-ai": "Use an AI assistant to handle conversations automatically.",
  "route-to-team":
    "Assign conversations to a specific team. Add Attribute conditions (right panel) to route by survey answer, URL, time of day, and more.",
  "create-crm-record":
    "Create a record in your CRM when a conversation starts.",
  "resolve-chat": "Automatically resolve conversations that match the conditions.",
  "use-workflow-on-resolve": "Run a workflow when a conversation is resolved.",
  "use-workflow-on-unavailable": "Run a workflow when no agents are available.",
  "use-prechat-survey":
    "Show a survey before the visitor starts chatting. Survey answers become variables you can use in routing rules.",
  "use-postchat-survey": "Show a satisfaction survey after the chat ends.",
  "use-unavailable-survey":
    "Show a survey when no agents are available to handle the chat.",
  "determine-chat-window": "Choose which chat window design to display.",
  "set-conversation-priority":
    "Flag matching conversations as High (1) or Urgent (2) priority. High-priority conversations bypass tier escalation and are highlighted in the agent inbox with a badge."
};

export interface Rule {
  // A collection of expressions and a priority for a trigger
  id?: number;
  trigger: RuleTrigger; //spot in the app where a rule needs to run
  priority: number; //order to run rules for a trigger
  expression: Expression;
  value: RuleValue;
}

// Supported CRM integrations for the "Create CRM Record" rule trigger.
// Add new CRMs here as they are integrated.
export const crmDefs = {
  NetSuite: "netsuite",
  Dynamics365: "dynamics365"
};
export type Crm = keyof typeof crmDefs;

// NetSuite record types (legacy — used when crmType === "netsuite")
export const crmRecordDefs = {
  Customer: "Customer",
  Account: "Account",
  SupportCase: "Support Case",
  Lead: "Lead",
  Prospect: "Prospect",
  Contact: "Contact",
  Order: "Order"
};
export type CrmRecord = keyof typeof crmRecordDefs;

// Dynamics 365 entity types
export const dynamicsEntityDefs = {
  Contact: "Contact",
  Account: "Account",
  Lead: "Lead",
  Opportunity: "Opportunity",
  Case: "Case",
  Note: "Note"
};
export type DynamicsEntity = keyof typeof dynamicsEntityDefs;
